import React from "react";

/**
 * Back button component with arrow icon
 */
const BackButton = ({ onClick, label = "Back" }) => {
  return (
    <button
      style={{
        background: "transparent",
        border: "none",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        padding: "4px 8px",
      }}
      onClick={onClick}
    >
      <svg
        viewBox="6 4 16 16"
        width="24"
        height="24"
        style={{ color: "black", display: "block" }}
      >
        <path
          d="M10 12h10M10 12l4-4M10 12l4 4"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{label}</span>
    </button>
  );
};

export default BackButton;
